import { TextField, outlinedInputClasses, inputClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
const StyledTextField = styled(TextField)(({ theme }) => ({
  padding: 0,
  marginLeft: "auto",
  [`& .${outlinedInputClasses.root}`]: {
    borderRadius: "2px",
    borderColor: theme.palette.grey[600],
    color: theme.palette.grey[800],
    minHeight: theme.spacing(2),
    [`&.${inputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: theme.palette.primary[800]
    }
  },
  "& input": {
    fontFamily: "'Lato'",
    fontWeight: 700,
    fontSize: "10px",
    lineHeight: "16px",
    letterSpacing: "0.5px",
    padding: theme.spacing(0, 0.5),
    width: "44px",
    height: "24px",
    textAlign: "center"
  },
  "& fieldset": {
    padding: 0
  }
}));
export {
  StyledTextField
};
